import { createContext } from 'react';

import useModal, { initModal } from './../../services/hooks/UI/useModal';

import useToast, { initToast } from '../../services/hooks/UI/useToast';

import useCollaborator, { initCollaborator } from '../../services/hooks/UI/useCollaborator';
import useSupplier, { initSupplier } from '../../services/hooks/UI/useSupplier';

const Context = createContext({
  modal: initModal,
  toast: initToast,
  collaborator: initCollaborator,
  supplier: initSupplier
});

export const ContextProvider = props => {
  const modal = useModal();
  const toast = useToast();
  const collaborator = useCollaborator();
  const supplier = useSupplier();

  return <Context.Provider value={{ modal, toast, collaborator, supplier }}>{props.children}</Context.Provider>;
};

export default Context;
